import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import { Typography } from '@/components/shared/Typography';
import css from './style.module.scss';
interface Props {
  className?: string;
  onClick: () => void;
  label?: string;
}
const ShowMoreFilledButton: FC<Props> = t0 => {
  const $ = _c(9);
  const {
    className,
    onClick,
    label
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx(css.button, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <Typography uppercase={true} variant="button-m" tag="span" className={css.buttonText}>{label}</Typography>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className={css.plusIcon} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.0833 6.33333H6.33333V11.0833H4.75V6.33333H0V4.75H4.75V0H6.33333V4.75H11.0833V6.33333Z" fill="currentColor" /></svg>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onClick || $[6] !== t1 || $[7] !== t2) {
    t4 = <button className={t1} type="button" onClick={onClick}>{t2}{t3}</button>;
    $[5] = onClick;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default ShowMoreFilledButton;